module.exports = __webpack_public_path__ + "img/responsive.e1619582.png";